import React, { FC } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'

interface TextareaInputProps {
  register: UseFormRegisterReturn
  placeholder?: string
  rows?: number
  className?: string
}

export const TextareaInput: FC<TextareaInputProps> = ({
  register,
  placeholder,
  rows = 5,
  className = '',
}) => {
  return (
    <textarea
      placeholder={placeholder}
      className={`w-full rounded-lg px-2 py-1 outline-none resize-none border border-main-bordergray placeholder:text-main-bordergray ${className}`}
      rows={rows}
      {...register}
    />
  )
}
